
import { defineComponent, ref } from '@vue/composition-api'
import type { InsuranceInfoRes } from 'api/api-type'
import Panel from './panel.vue'

export default defineComponent({
  name: 'self-advantage',
  setup() {
    const advantages = ref<InsuranceInfoRes['advantage']['content']>([{
      title: '补贴同款',
      content: '同款保障，专属服务',
      image_url: 'https://dpubstatic.udache.com/static/dpubimg/5b36f778-2f98-4c0e-ac31-d2d7ee6d29a3.png'
    }, {
      title: '灵活加投',
      content: '自主选择，叠加保障',
      image_url: 'https://dpubstatic.udache.com/static/dpubimg/694bd619-4611-487f-8304-cfdb8c16081f.png'
    }])
    return {
      advantages
    }
  },
  components: {
    Panel
  }
})
